import axios from 'axios'
import { replace, push } from 'connected-react-router'
import { SubmissionError } from 'redux-form'
import * as types from '../constants/actionTypes'
import exceptionTrack from '../tools/exceptions'
import * as Sentry from '@sentry/browser'
import { resetRefiApplication } from './refiApplicationActions'

export const requestSession = () => ({
  type: types.RequestSession,
})

export const createSession = (user) => {
  try {
    exceptionTrack.setUser({
      email: user.email,
      id: user.id,
    })
  } catch (err) {
    Sentry.withScope((scope) => {
      scope.setExtra('debug', false)
      Sentry.captureException(err)
    })
  }

  return {
    type: types.CreateSession,
    user,
  }
}

export const requestSessionSuccess = () => ({
  type: types.RequestSessionSuccess,
})

export const requestSessionFailure = (error) => ({
  type: types.RequestSessionFailure,
  error,
})

export const destroySession = () => ({
  type: types.DestroySession,
})

export const showDuo = (sigRequest) => {
  return {
    type: types.ShowDuo,
    sigRequest,
  }
}

export const hideDuo = () => {
  return {
    type: types.HideDuo,
  }
}

export const createLocalStore = (data) => {
  localStorage.setItem('accessToken', JSON.stringify(data.access_token))
  localStorage.setItem('userData', JSON.stringify(data.user))
  return (dispatch) => {
    // dispatch create local store message
    dispatch(createSession(data.user))
  }
}

export const getAccessToken = () => {
  return localStorage.getItem('accessToken')
}

export const getUserData = () => {
  const userData = localStorage.getItem('userData')
  return userData && JSON.parse(userData)
}

export const destroyLocalStore = () => {
  localStorage.removeItem('accessToken')
  localStorage.removeItem('userData')
  //dispatch destroy local store message
}

export const logoutHandler = () => {
  return (dispatch) => {
    dispatch(destroySession())
    dispatch(resetRefiApplication())
    destroyLocalStore()
    dispatch(replace('/login'))
  }
}

export const submitLogin = (data) => {
  return (dispatch) => {
    dispatch(requestSession())
    return axios
      .post(`${process.env.REACT_APP_BLINKER_API_URL}/oauth/login`, {
        username: data.email,
        password: data.password,
        grant_type: 'password',
      })
      .then((res) => {
        if (res.data.sign_request) {
          dispatch(showDuo(res.data.sign_request))
        } else {
          dispatch(requestSessionSuccess())
          dispatch(createLocalStore(res.data))
        }
      })
      .catch((error) => {
        const errorMesssage =
          error.response && error.response.data
            ? error.response.data.message
            : 'Something went wrong'
        throw new SubmissionError({
          email: errorMesssage,
          password: errorMesssage,
        })
        dispatch(requestSessionFailure(error))
      })
  }
}

export const submitDuoLogin = (action, sigResponse) => {
  return (dispatch) => {
    return axios
      .post(action, { sig_response: sigResponse })
      .then((res) => {
        dispatch(createLocalStore(res.data))
        dispatch(push('/'))
      })
      .catch((error) => {
        dispatch(hideDuo())
        dispatch(requestSessionFailure(error))
      })
  }
}

export const checkIsAuth = (store) => {
  const authed = store.getState().session.isAuth

  if (authed) {
    return true
  }

  const localToken = getAccessToken()

  if (!!localToken) {
    const tokenData = JSON.parse(localToken)
    const expirationTime =
      new Date(tokenData.created_at).getTime() + tokenData.expires_in * 1000
    const currentTime = Date.now()

    if (expirationTime > currentTime) {
      store.dispatch(createSession(getUserData()))
      return true
    }
  }

  return false
}
